exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ql-toolbar.ql-snow {\n  border-top-right-radius: .25rem;\n  border-top-left-radius: .25rem;\n}\n.ql-container.ql-snow {\n  border-bottom-right-radius: .25rem;\n  border-bottom-left-radius: .25rem;\n}\n.ql-toolbar.ql-snow .ql-variables .ql-picker-label {\n  padding-right: 18px;\n}\n", ""]);

// exports
